import { createBrowserRouter, Navigate } from 'react-router';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/Login';
import { AuthCallbackPage } from './pages/AuthCallback';
import { ClientsPage, ClientDetailPage } from './pages/Clients';
import { ProjectsPage } from './pages/Projects';
import { ProjectPage } from './pages/Project';
import { InstancePage } from './pages/Instance';
import { ChatPage } from './pages/Chat';
import { Test360Page } from './pages/Test360';
import { AgentsPage } from './pages/Agents';
import { CharacterCreatorPage } from './pages/CharacterCreator';
import { BackgroundsPage } from './pages/Backgrounds';
import { BillingPage } from './pages/Billing';
import { CostsPage } from './pages/Costs';
import { ElevenlabsAccountPage } from './pages/ElevenlabsAccount';
import { KeyframeSequencePage } from './pages/KeyframeSequence';
import { SceneSeriesPage } from './pages/SceneSeries';
import { SceneSeriesNewPage } from './pages/SceneSeriesNew';
import { VideoPage } from './pages/Video';
import { JobsPage } from './pages/Jobs';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/auth/callback', element: <AuthCallbackPage /> },
  // Página standalone — sin Layout, sin auth obligatoria — para comparar
  // estrategias de stitching 360 contra outputs ya generados (URLs hardcodeadas).
  { path: '/test-360', element: <Test360Page /> },
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Navigate to="/projects" replace /> },
      { path: 'clients', element: <ClientsPage /> },
      { path: 'clients/:clientId', element: <ClientDetailPage /> },
      { path: 'projects', element: <ProjectsPage /> },
      { path: 'projects/:projectSlug', element: <ProjectPage /> },
      { path: 'projects/:projectSlug/instances/:instanceSlug', element: <InstancePage /> },
      { path: 'chats/:chatId', element: <ChatPage /> },
      { path: 'agents', element: <AgentsPage /> },
      { path: 'character-creator', element: <CharacterCreatorPage /> },
      { path: 'backgrounds', element: <BackgroundsPage /> },
      { path: 'billing', element: <BillingPage /> },
      { path: 'costs', element: <CostsPage /> },
      { path: 'admin/elevenlabs-account', element: <ElevenlabsAccountPage /> },
      { path: 'keyframe-sequence', element: <KeyframeSequencePage /> },
      { path: 'scene-series/nueva', element: <SceneSeriesNewPage /> },
      { path: 'scene-series/:seriesId', element: <SceneSeriesPage /> },
      { path: 'video', element: <VideoPage /> },
      { path: 'jobs', element: <JobsPage /> },
    ],
  },
]);
